import React from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import useContactUs from "../../../hooks/useContactUs";

const ContactUsForm = ({ t }) => {
  const { handleChange, handleSubmit, validated, typesSelect } =
    useContactUs(t);
  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row>
        <Form.Group as={Col} controlId="validationCustom01">
          <InputGroup hasValidation>
            <Form.Control
              type="text"
              placeholder={t("register.name")}
              name="name"
              onChange={handleChange}
              required
            />
            <Form.Control.Feedback type="invalid">
              {`${t("register.noFill")} ${t("register.name")}`}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>

        <Form.Group as={Col} controlId="validationCustom01">
          <InputGroup hasValidation>
            <Form.Control
              type="text"
              placeholder={t("register.lastName")}
              name="lastName"
              onChange={handleChange}
              required
            />
            <Form.Control.Feedback type="invalid">
              {`${t("register.noFill")} ${t("register.lastName")}`}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} controlId="validationCustom01">
          <InputGroup hasValidation>
            <Form.Control
              type="email"
              placeholder={t("register.email")}
              name="email"
              onChange={handleChange}
              required
            />
            <Form.Control.Feedback type="invalid">
              {`${t("register.noFill")} ${t("register.email")}`}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>

        <Form.Group as={Col} controlId="validationCustom01">
          <InputGroup hasValidation>
            <Form.Control
              type="textarea"
              placeholder={t("contact.phone")}
              name="phone"
              onChange={handleChange}
              required
              maxLength={10}
              minLength={10}
            />
            <Form.Control.Feedback type="invalid">
              {`${t("register.noFill")} ${t("contact.phone")}`}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} controlId="validationCustom01">
          <InputGroup hasValidation>
            <Form.Control
              type="textarea"
              placeholder={t("contact.message")}
              rows={3}
              name="description"
              onChange={handleChange}
              required
            />
            <Form.Control.Feedback type="invalid">
              {`${t("register.noFill")} ${t("contact.message")}`}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} controlId="validationCustom01">
          <Form.Control
            as="select"
            custom
            name="typeId"
            onChange={handleChange}
          >
            {typesSelect.map((type) => (
              <option value={type.id}>{type.description}</option>
            ))}
          </Form.Control>
        </Form.Group>
      </Row>
      <Button variant="primary" type="submit">
        {t("contact.send")}
      </Button>
    </Form>
  );
};

export default ContactUsForm;
